import React, { useEffect, useState, Fragment } from 'react';
import { Heart, Star, Gift, Lock, CheckCircle, Clock, Zap, ArrowLeft, User, Filter, Search, ChevronRight, Plus, Bell, Share2, Play, Tag, X, Sparkles } from 'lucide-react';
interface PremiumContentProps {
  onBack: () => void;
}
export const PremiumContent: React.FC<PremiumContentProps> = ({
  onBack
}) => {
  const [activeTab, setActiveTab] = useState('new');
  const [claimedDailyReward, setClaimedDailyReward] = useState(false);
  const [premiumUnlocked, setPremiumUnlocked] = useState(0);
  const [showGemPurchase, setShowGemPurchase] = useState(false);
  const [selectedContent, setSelectedContent] = useState<any | null>(null);
  const [showUnlockModal, setShowUnlockModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [showFilters, setShowFilters] = useState(false);
  const [filterCategory, setFilterCategory] = useState<string | null>(null);
  const [showSuccessToast, setShowSuccessToast] = useState(false);
  const [gemBalance, setGemBalance] = useState(15);
  // Sample premium content data
  const premiumContent = [{
    id: 'premium1',
    title: 'Intimate Bedroom Session',
    angel: 'Sophia',
    angelAvatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/uyiXhnExYU79VjyGrEvQrS/masturbate.jpg',
    tags: ['#intimate', '#bedroom', '#exclusive'],
    price: 20,
    likes: 1243,
    isLocked: true,
    isPremium: true,
    type: 'video',
    duration: '5:23',
    uploadedAt: '2 hours ago',
    category: 'new'
  }, {
    id: 'premium2',
    title: 'VR Shower Experience',
    angel: 'Harper',
    angelAvatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8g53dZ7J3kRR9dJNnGuDbc/h2.png',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8g53dZ7J3kRR9dJNnGuDbc/h2.png',
    tags: ['#VR', '#shower', '#POV'],
    price: 35,
    likes: 987,
    isLocked: true,
    isPremium: true,
    type: 'vr',
    duration: '7:45',
    uploadedAt: '5 hours ago',
    category: 'vr'
  }, {
    id: 'premium3',
    title: 'FanClub Exclusive: Lingerie Try-On',
    angel: 'Lana',
    angelAvatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
    tags: ['#fanclub', '#lingerie', '#exclusive'],
    price: 15,
    likes: 2156,
    isLocked: true,
    isPremium: true,
    type: 'photoset',
    photoCount: 24,
    uploadedAt: '1 day ago',
    category: 'fanclub'
  }, {
    id: 'premium4',
    title: 'Yoga Stretching Routine',
    angel: 'Bonny Blue',
    angelAvatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/jq4Dkth7vgkmZJ8GZmzWDP/bonnyblue.png',
    tags: ['#yoga', '#flexible', '#workout'],
    price: 0,
    likes: 876,
    isLocked: false,
    isPremium: false,
    type: 'video',
    duration: '3:12',
    uploadedAt: '6 hours ago',
    category: 'free'
  }, {
    id: 'premium5',
    title: 'Poolside Photoshoot',
    angel: 'Kim Holland',
    angelAvatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/bZ3iVXv5nZEMY6F847weq5/kimholland.png',
    tags: ['#pool', '#summer', '#bikini'],
    price: 25,
    likes: 1542,
    isLocked: true,
    isPremium: true,
    type: 'photoset',
    photoCount: 18,
    uploadedAt: '3 hours ago',
    category: 'popular'
  }, {
    id: 'premium6',
    title: 'Morning Coffee Tease',
    angel: 'Sophia',
    angelAvatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/3qpuRUm6dCq7zBHVh1QApz/image.png',
    tags: ['#morning', '#coffee', '#tease'],
    price: 0,
    likes: 743,
    isLocked: false,
    isPremium: false,
    type: 'video',
    duration: '2:10',
    uploadedAt: '1 day ago',
    category: 'free'
  }, {
    id: 'premium7',
    title: 'Bedroom Secrets',
    angel: 'Lana',
    angelAvatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/cLp9w3hC4dVahxHuCeYw1i/488653244_669275086051024_406085801635574977_n.jpg',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/t1fMgo9T4WadxWeynPJ6vb/videoblur.png',
    tags: ['#bedroom', '#secrets', '#intimate'],
    price: 30,
    likes: 1876,
    isLocked: true,
    isPremium: true,
    type: 'video',
    duration: '8:45',
    uploadedAt: '12 hours ago',
    category: 'popular'
  }, {
    id: 'premium8',
    title: 'AR Lap Dance Experience',
    angel: 'Harper',
    angelAvatar: 'https://uploadthingy.s3.us-west-1.amazonaws.com/8g53dZ7J3kRR9dJNnGuDbc/h2.png',
    image: 'https://uploadthingy.s3.us-west-1.amazonaws.com/t1fMgo9T4WadxWeynPJ6vb/videoblur.png',
    tags: ['#AR', '#dance', '#interactive'],
    price: 40,
    likes: 1243,
    isLocked: true,
    isPremium: true,
    type: 'ar',
    duration: '10:00',
    uploadedAt: '2 days ago',
    category: 'vr'
  }];
  // Gem bundle options
  const gemBundles = [{
    amount: 20,
    price: '$1.99',
    discount: '30% OFF',
    isPopular: false
  }, {
    amount: 50,
    price: '$4.99',
    discount: '30% OFF',
    isPopular: true
  }, {
    amount: 100,
    price: '$9.99',
    discount: '30% OFF',
    isPopular: false
  }];
  const handleBackClick = () => {
    // Use the global navigation function if available
    const navigateEvent = new CustomEvent('navigate', {
      detail: {
        section: 'social_feed'
      }
    });
    document.dispatchEvent(navigateEvent);
    onBack();
  };
  const handleAngelClick = (angelName: string) => {
    console.log(`Navigate to ${angelName}'s profile`);
    // Implement navigation to angel profile
  };
  const handleContentClick = (content: any) => {
    setSelectedContent(content);
    if (content.isLocked) {
      setShowUnlockModal(true);
    } else {
      // Implement view content logic for unlocked content
      console.log(`Viewing unlocked content: ${content.title}`);
    }
  };
  const handleUnlock = () => {
    if (selectedContent && gemBalance >= selectedContent.price) {
      // Unlock the content
      setGemBalance(gemBalance - selectedContent.price);
      setPremiumUnlocked(premiumUnlocked + 1);
      // Update the selected content's lock status
      const updatedContent = {
        ...selectedContent,
        isLocked: false
      };
      setSelectedContent(updatedContent);
      // Close the modal
      setShowUnlockModal(false);
      // Show success toast
      setShowSuccessToast(true);
      setTimeout(() => setShowSuccessToast(false), 3000);
    } else {
      // Not enough gems, show purchase modal
      setShowUnlockModal(false);
      setShowGemPurchase(true);
    }
  };
  const handleGemPurchase = (amount: number) => {
    // Simulate gem purchase
    setGemBalance(gemBalance + amount);
    setShowGemPurchase(false);
    // If there was a pending content unlock, reopen that modal
    if (selectedContent) {
      setShowUnlockModal(true);
    }
  };
  const handleClaimDailyReward = () => {
    setClaimedDailyReward(true);
    // Implement daily reward logic
    console.log('Daily reward claimed');
  };
  const filteredContent = premiumContent.filter(content => {
    // Filter by tab
    if (activeTab === 'new' && content.category !== 'new') {
      return false;
    }
    if (activeTab === 'popular' && content.category !== 'popular') {
      return false;
    }
    if (activeTab === 'fanclub' && content.category !== 'fanclub') {
      return false;
    }
    if (activeTab === 'vr' && content.category !== 'vr') {
      return false;
    }
    if (activeTab === 'free' && content.category !== 'free') {
      return false;
    }
    // Filter by search query
    if (searchQuery && !content.title.toLowerCase().includes(searchQuery.toLowerCase()) && !content.angel.toLowerCase().includes(searchQuery.toLowerCase()) && !content.tags.some((tag: string) => tag.toLowerCase().includes(searchQuery.toLowerCase()))) {
      return false;
    }
    // Filter by category
    if (filterCategory) {
      if (filterCategory === 'video' && content.type !== 'video') {
        return false;
      }
      if (filterCategory === 'photoset' && content.type !== 'photoset') {
        return false;
      }
      if (filterCategory === 'vr' && content.type !== 'vr' && content.type !== 'ar') {
        return false;
      }
      if (filterCategory === 'locked' && !content.isLocked) {
        return false;
      }
      if (filterCategory === 'free' && content.price > 0) {
        return false;
      }
    }
    return true;
  });
  // Check if user has completed the daily target
  const hasDailyTargetComplete = premiumUnlocked > 0;
  return <div className="w-full max-w-7xl mx-auto bg-white dark:bg-gray-950 text-gray-900 dark:text-white min-h-screen" data-id="element-15710">
      {/* Header */}
      <div className="sticky top-0 z-20 bg-white/90 dark:bg-gray-900/90 backdrop-blur-sm border-b border-gray-200 dark:border-gray-800" data-id="element-15711">
        <div className="px-4 py-3 flex items-center justify-between" data-id="element-15712">
          <div className="flex items-center gap-3" data-id="element-15713">
            <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full" onClick={handleBackClick} data-id="element-15714">
              <ArrowLeft size={18} className="text-gray-700 dark:text-gray-300" data-id="element-15715" />
            </button>
            <div data-id="element-15716">
              <h1 className="font-bold text-xl flex items-center gap-2" data-id="element-15717">
                🔥 Unlock Exclusive Angel Content
              </h1>
              <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-15718">
                Buy once. Crave forever.
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3" data-id="element-15719">
            <div className="bg-gray-100 dark:bg-gray-800 px-3 py-1 rounded-full flex items-center gap-2" data-id="element-15720">
              <span className="text-pink-500 font-bold" data-id="element-15721">{gemBalance}</span>
              <span className="text-lg" data-id="element-15722">💎</span>
            </div>
            <button className="p-2 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-full relative" onClick={() => setShowFilters(!showFilters)} data-id="element-15723">
              <Filter size={18} className="text-gray-700 dark:text-gray-300" data-id="element-15724" />
              {filterCategory && <span className="absolute -top-1 -right-1 w-2 h-2 bg-pink-500 rounded-full" data-id="element-15725"></span>}
            </button>
          </div>
        </div>
        {/* Progress Bar */}
        <div className="px-4 py-2 bg-gradient-to-r from-pink-500/10 to-purple-500/10" data-id="element-15726">
          <div className="flex items-center justify-between mb-1" data-id="element-15727">
            <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-15728">
              You've unlocked {premiumUnlocked}/1 premium content today
            </span>
            {hasDailyTargetComplete && !claimedDailyReward && <button onClick={handleClaimDailyReward} className="px-3 py-1 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-xs font-medium flex items-center gap-1" data-id="element-15729">
                <Gift size={12} data-id="element-15730" />
                <span data-id="element-15731">Claim Daily Target Reward</span>
              </button>}
            {claimedDailyReward && <div className="flex items-center gap-1 text-green-500 text-xs" data-id="element-15732">
                <CheckCircle size={12} data-id="element-15733" />
                <span data-id="element-15734">Daily Target Complete!</span>
              </div>}
          </div>
          <div className="h-1.5 bg-gray-200 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-15735">
            <div className="h-full bg-gradient-to-r from-pink-500 to-purple-500 rounded-full transition-all duration-300" style={{
            width: `${premiumUnlocked / 1 * 100}%`
          }} data-id="element-15736"></div>
          </div>
        </div>
        {/* Search Bar */}
        <div className="p-3 border-t border-gray-200 dark:border-gray-800" data-id="element-15737">
          <div className="relative" data-id="element-15738">
            <input type="text" placeholder="Search premium content..." className="w-full bg-gray-100 dark:bg-gray-800 rounded-full py-2 pl-10 pr-4 text-sm" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} data-id="element-15739" />
            <Search size={16} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-15740" />
          </div>
        </div>
        {/* Filters */}
        {showFilters && <div className="p-3 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-800 animate-in slide-in-from-top duration-300" data-id="element-15741">
            <h3 className="font-medium mb-2 text-sm" data-id="element-15742">Filter by type:</h3>
            <div className="flex flex-wrap gap-2" data-id="element-15743">
              <button className={`px-3 py-1.5 rounded-full text-xs ${filterCategory === 'video' ? 'bg-pink-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300'}`} onClick={() => setFilterCategory(filterCategory === 'video' ? null : 'video')} data-id="element-15744">
                Videos
              </button>
              <button className={`px-3 py-1.5 rounded-full text-xs ${filterCategory === 'photoset' ? 'bg-pink-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300'}`} onClick={() => setFilterCategory(filterCategory === 'photoset' ? null : 'photoset')} data-id="element-15745">
                Photosets
              </button>
              <button className={`px-3 py-1.5 rounded-full text-xs ${filterCategory === 'vr' ? 'bg-pink-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300'}`} onClick={() => setFilterCategory(filterCategory === 'vr' ? null : 'vr')} data-id="element-15746">
                VR/AR
              </button>
              <button className={`px-3 py-1.5 rounded-full text-xs ${filterCategory === 'locked' ? 'bg-pink-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300'}`} onClick={() => setFilterCategory(filterCategory === 'locked' ? null : 'locked')} data-id="element-15747">
                Premium Only
              </button>
              <button className={`px-3 py-1.5 rounded-full text-xs ${filterCategory === 'free' ? 'bg-pink-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300'}`} onClick={() => setFilterCategory(filterCategory === 'free' ? null : 'free')} data-id="element-15748">
                Free Content
              </button>
            </div>
          </div>}
        {/* Navigation Tabs */}
        <div className="flex overflow-x-auto py-2 px-4 gap-2 border-t border-gray-200 dark:border-gray-800 scrollbar-hide" data-id="element-15749">
          <button onClick={() => setActiveTab('new')} className={`flex items-center gap-1.5 px-4 py-2 rounded-full whitespace-nowrap transition-all ${activeTab === 'new' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} data-id="element-15750">
            <span data-id="element-15751">🆕</span>
            <span data-id="element-15752">New</span>
          </button>
          <button onClick={() => setActiveTab('popular')} className={`flex items-center gap-1.5 px-4 py-2 rounded-full whitespace-nowrap transition-all ${activeTab === 'popular' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} data-id="element-15753">
            <span data-id="element-15754">🔥</span>
            <span data-id="element-15755">Popular</span>
          </button>
          <button onClick={() => setActiveTab('fanclub')} className={`flex items-center gap-1.5 px-4 py-2 rounded-full whitespace-nowrap transition-all ${activeTab === 'fanclub' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} data-id="element-15756">
            <span data-id="element-15757">💎</span>
            <span data-id="element-15758">FanClub</span>
          </button>
          <button onClick={() => setActiveTab('vr')} className={`flex items-center gap-1.5 px-4 py-2 rounded-full whitespace-nowrap transition-all ${activeTab === 'vr' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} data-id="element-15759">
            <span data-id="element-15760">🥽</span>
            <span data-id="element-15761">AR/VR</span>
          </button>
          <button onClick={() => setActiveTab('free')} className={`flex items-center gap-1.5 px-4 py-2 rounded-full whitespace-nowrap transition-all ${activeTab === 'free' ? 'bg-gradient-to-r from-pink-600 to-purple-600 text-white' : 'bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700'}`} data-id="element-15762">
            <span data-id="element-15763">🎁</span>
            <span data-id="element-15764">Free Teasers</span>
          </button>
        </div>
      </div>
      {/* Content Grid */}
      <div className="p-4" data-id="element-15765">
        {filteredContent.length === 0 ? <div className="flex flex-col items-center justify-center py-12 text-center" data-id="element-15766">
            <div className="w-16 h-16 flex items-center justify-center bg-gray-100 dark:bg-gray-800 rounded-full mb-4" data-id="element-15767">
              <Search size={24} className="text-gray-400" data-id="element-15768" />
            </div>
            <h3 className="text-lg font-bold mb-2" data-id="element-15769">No content found</h3>
            <p className="text-gray-600 dark:text-gray-400 max-w-md" data-id="element-15770">
              Try adjusting your search or filters to find what you're looking
              for.
            </p>
          </div> : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-15771">
            {filteredContent.map((content, index) => <Fragment key={content.id} data-id="element-15772">
                {/* Insert promo after every 3rd item */}
                {index === 3 && <div className="col-span-1 sm:col-span-2 lg:col-span-3 p-4 bg-gradient-to-r from-pink-500/10 to-purple-500/10 rounded-lg border border-pink-500/20 my-4" data-id="element-15773">
                    <div className="flex flex-col md:flex-row items-center justify-between gap-4" data-id="element-15774">
                      <div data-id="element-15775">
                        <div className="flex items-center gap-2" data-id="element-15776">
                          <span className="text-2xl" data-id="element-15777">🔥</span>
                          <h3 className="font-bold text-lg" data-id="element-15778">
                            30% off First DesireGem Bundle
                          </h3>
                        </div>
                        <p className="text-sm text-gray-600 dark:text-gray-400 mt-1" data-id="element-15779">
                          Limited time offer - expires in
                          <span className="text-pink-500 font-medium ml-1" data-id="element-15780">
                            23:45:12
                          </span>
                        </p>
                      </div>
                      <div className="flex flex-wrap gap-2 justify-center" data-id="element-15781">
                        {gemBundles.map(bundle => <div key={bundle.amount} className={`relative p-3 border rounded-lg cursor-pointer transition-all hover:shadow-md ${bundle.isPopular ? 'border-pink-500 bg-gradient-to-br from-pink-500/5 to-purple-500/5' : 'border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900'}`} onClick={() => handleGemPurchase(bundle.amount)} data-id="element-15782">
                            {bundle.isPopular && <div className="absolute -top-2 -right-2 bg-pink-500 text-white text-xs px-2 py-0.5 rounded-full" data-id="element-15783">
                                Best Value
                              </div>}
                            <div className="text-center" data-id="element-15784">
                              <div className="text-xl font-bold mb-1" data-id="element-15785">
                                {bundle.amount} 💎
                              </div>
                              <div className="text-sm font-medium" data-id="element-15786">
                                {bundle.price}
                              </div>
                              <div className="text-xs text-pink-500 mt-1" data-id="element-15787">
                                {bundle.discount}
                              </div>
                            </div>
                          </div>)}
                      </div>
                    </div>
                  </div>}
                {/* Content card */}
                <div className="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-800 rounded-lg overflow-hidden shadow-sm hover:shadow-md transition-all cursor-pointer" onClick={() => handleContentClick(content)} data-id="element-15788">
                  <div className="relative" data-id="element-15789">
                    <img src={content.image} alt={content.title} className={`w-full aspect-video object-cover ${content.isLocked ? 'filter blur-sm' : ''}`} data-id="element-15790" />
                    {content.isLocked && <div className="absolute inset-0 flex flex-col items-center justify-center bg-black/50" data-id="element-15791">
                        <Lock size={24} className="text-white mb-2" data-id="element-15792" />
                        <button className="px-4 py-1.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-full text-white text-sm font-medium" data-id="element-15793">
                          Unlock for {content.price} 💎
                        </button>
                      </div>}
                    {!content.isLocked && content.type === 'video' && <div className="absolute inset-0 flex items-center justify-center" data-id="element-15794">
                        <div className="w-12 h-12 rounded-full bg-black/50 flex items-center justify-center" data-id="element-15795">
                          <Play size={24} className="text-white ml-1" data-id="element-15796" />
                        </div>
                      </div>}
                    <div className="absolute top-2 right-2 bg-black/70 backdrop-blur-sm px-2 py-0.5 rounded-full text-xs text-white flex items-center gap-1" data-id="element-15797">
                      <Heart size={12} className="text-pink-500" fill="currentColor" data-id="element-15798" />
                      <span data-id="element-15799">{content.likes}</span>
                    </div>
                    <div className="absolute top-2 left-2 bg-black/70 backdrop-blur-sm px-2 py-0.5 rounded-full text-xs text-white" data-id="element-15800">
                      {content.isPremium ? '💎 Premium' : '🎁 Free'}
                    </div>
                    {content.type === 'video' && <div className="absolute bottom-2 right-2 bg-black/70 backdrop-blur-sm px-2 py-0.5 rounded-full text-xs text-white flex items-center gap-1" data-id="element-15801">
                        <Clock size={12} data-id="element-15802" />
                        <span data-id="element-15803">{content.duration}</span>
                      </div>}
                    {content.type === 'photoset' && <div className="absolute bottom-2 right-2 bg-black/70 backdrop-blur-sm px-2 py-0.5 rounded-full text-xs text-white flex items-center gap-1" data-id="element-15804">
                        <span data-id="element-15805">📸</span>
                        <span data-id="element-15806">{content.photoCount} photos</span>
                      </div>}
                    {(content.type === 'vr' || content.type === 'ar') && <div className="absolute bottom-2 right-2 bg-gradient-to-r from-blue-600 to-purple-600 px-2 py-0.5 rounded-full text-xs text-white font-bold flex items-center gap-1" data-id="element-15807">
                        {content.type === 'vr' ? 'VR' : 'AR'}
                      </div>}
                  </div>
                  <div className="p-3" data-id="element-15808">
                    <div className="flex items-start justify-between" data-id="element-15809">
                      <div data-id="element-15810">
                        <h3 className="font-medium text-sm line-clamp-1" data-id="element-15811">
                          {content.title}
                        </h3>
                        <div className="flex items-center gap-1 mt-1 cursor-pointer" onClick={e => {
                    e.stopPropagation();
                    handleAngelClick(content.angel);
                  }} data-id="element-15812">
                          <img src={content.angelAvatar} alt={content.angel} className="w-5 h-5 rounded-full object-cover" data-id="element-15813" />
                          <span className="text-xs text-gray-600 dark:text-gray-400" data-id="element-15814">
                            {content.angel}
                          </span>
                          <CheckCircle size={10} className="text-pink-500" fill="currentColor" data-id="element-15815" />
                        </div>
                      </div>
                      <div className="text-xs text-gray-500 dark:text-gray-400" data-id="element-15816">
                        {content.uploadedAt}
                      </div>
                    </div>
                    <div className="flex flex-wrap gap-1 mt-2" data-id="element-15817">
                      {content.tags.map((tag: string, i: number) => <span key={i} className="text-xs bg-gray-100 dark:bg-gray-800 text-gray-600 dark:text-gray-400 px-1.5 py-0.5 rounded-full" data-id="element-15818">
                          {tag}
                        </span>)}
                    </div>
                  </div>
                </div>
              </Fragment>)}
          </div>}
      </div>
      {/* Footer CTA */}
      <div className="mt-8 p-6 bg-gradient-to-r from-pink-500/10 to-purple-500/10 border-t border-pink-500/20" data-id="element-15819">
        <div className="max-w-3xl mx-auto text-center" data-id="element-15820">
          <h3 className="text-xl font-bold mb-2" data-id="element-15821">Want More?</h3>
          <p className="text-gray-600 dark:text-gray-400 mb-4" data-id="element-15822">
            Create Your Own Angel With Unleash or Join a FanClub & Get Free
            Daily Premium Drops
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center" data-id="element-15823">
            <button className="px-6 py-2.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white font-medium hover:shadow-lg hover:shadow-pink-500/20 transition-all" onClick={() => {
            const navigateEvent = new CustomEvent('navigate', {
              detail: {
                section: 'unleash'
              }
            });
            document.dispatchEvent(navigateEvent);
          }} data-id="element-15824">
              Create Your Angel
            </button>
            <button className="px-6 py-2.5 bg-white dark:bg-gray-800 border border-pink-500 rounded-lg text-pink-600 dark:text-pink-400 font-medium hover:shadow-lg hover:shadow-pink-500/10 transition-all" data-id="element-15825">
              Join a FanClub
            </button>
          </div>
        </div>
      </div>
      {/* Unlock Modal */}
      {showUnlockModal && selectedContent && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-15826">
          <div className="w-full max-w-md bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 overflow-hidden animate-in zoom-in-90 duration-300" data-id="element-15827">
            <div className="p-4 border-b border-gray-200 dark:border-gray-800 flex justify-between items-center" data-id="element-15828">
              <h3 className="font-bold text-lg" data-id="element-15829">Unlock Premium Content</h3>
              <button onClick={() => setShowUnlockModal(false)} className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-15830">
                <X size={20} data-id="element-15831" />
              </button>
            </div>
            <div className="p-4" data-id="element-15832">
              <div className="flex items-center gap-3 mb-4" data-id="element-15833">
                <img src={selectedContent.angelAvatar} alt={selectedContent.angel} className="w-12 h-12 rounded-full object-cover" data-id="element-15834" />
                <div data-id="element-15835">
                  <h4 className="font-medium" data-id="element-15836">{selectedContent.title}</h4>
                  <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-15837">
                    By {selectedContent.angel}
                  </p>
                </div>
              </div>
              <div className="relative rounded-lg overflow-hidden mb-4" data-id="element-15838">
                <img src={selectedContent.image} alt={selectedContent.title} className="w-full aspect-video object-cover filter blur-sm" data-id="element-15839" />
                <div className="absolute inset-0 flex items-center justify-center bg-black/50" data-id="element-15840">
                  <Lock size={32} className="text-white" data-id="element-15841" />
                </div>
              </div>
              <p className="text-gray-600 dark:text-gray-400 mb-4 text-sm" data-id="element-15842">
                Unlock this exclusive content for {selectedContent.price} gems.
                This is a one-time purchase.
              </p>
              <div className="flex items-center justify-between mb-4" data-id="element-15843">
                <div className="flex items-center gap-2" data-id="element-15844">
                  <span className="text-sm text-gray-600 dark:text-gray-400" data-id="element-15845">
                    Your balance:
                  </span>
                  <span className="font-bold" data-id="element-15846">{gemBalance} 💎</span>
                </div>
                <div className="flex items-center gap-1 text-sm text-pink-600 dark:text-pink-400" data-id="element-15847">
                  <Zap size={14} data-id="element-15848" />
                  <span data-id="element-15849">+10 XP on unlock</span>
                </div>
              </div>
              <div className="flex gap-2" data-id="element-15850">
                <button className="flex-1 py-2.5 bg-gray-100 dark:bg-gray-800 rounded-lg text-gray-600 dark:text-gray-400 text-sm font-medium" onClick={() => setShowUnlockModal(false)} data-id="element-15851">
                  Cancel
                </button>
                <button className="flex-1 py-2.5 bg-gradient-to-r from-pink-600 to-purple-600 rounded-lg text-white text-sm font-medium flex items-center justify-center gap-2" onClick={handleUnlock} data-id="element-15852">
                  <Sparkles size={16} data-id="element-15853" />
                  <span data-id="element-15854">Unlock for {selectedContent.price} 💎</span>
                </button>
              </div>
              {gemBalance < selectedContent.price && <div className="mt-3 text-center" data-id="element-15855">
                  <button className="text-sm text-pink-600 dark:text-pink-400 underline" onClick={() => {
              setShowUnlockModal(false);
              setShowGemPurchase(true);
            }} data-id="element-15856">
                    Need more gems? Buy now
                  </button>
                </div>}
            </div>
          </div>
        </div>}
      {/* Gem Purchase Modal */}
      {showGemPurchase && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/80 backdrop-blur-sm animate-in fade-in duration-300" data-id="element-15857">
          <div className="w-full max-w-md bg-white dark:bg-gray-900 rounded-xl border border-gray-200 dark:border-gray-800 overflow-hidden animate-in zoom-in-90 duration-300" data-id="element-15858">
            <div className="p-4 border-b border-gray-200 dark:border-gray-800 flex justify-between items-center" data-id="element-15859">
              <h3 className="font-bold text-lg" data-id="element-15860">Buy DesireGems</h3>
              <button onClick={() => setShowGemPurchase(false)} className="p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800" data-id="element-15861">
                <X size={20} data-id="element-15862" />
              </button>
            </div>
            <div className="p-4" data-id="element-15863">
              <div className="mb-4" data-id="element-15864">
                <div className="flex items-center gap-2 mb-2" data-id="element-15865">
                  <span className="text-xl" data-id="element-15866">🔥</span>
                  <h4 className="font-medium" data-id="element-15867">30% Off First Purchase</h4>
                </div>
                <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-15868">
                  Special offer: Get 30% extra gems on your first purchase!
                </p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mb-6" data-id="element-15869">
                {gemBundles.map(bundle => <div key={bundle.amount} className={`relative p-4 border rounded-lg cursor-pointer transition-all hover:shadow-md ${bundle.isPopular ? 'border-pink-500 bg-gradient-to-br from-pink-500/5 to-purple-500/5' : 'border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-900'}`} onClick={() => handleGemPurchase(bundle.amount)} data-id="element-15870">
                    {bundle.isPopular && <div className="absolute -top-2 -right-2 bg-pink-500 text-white text-xs px-2 py-0.5 rounded-full" data-id="element-15871">
                        Best Value
                      </div>}
                    <div className="text-center" data-id="element-15872">
                      <div className="text-2xl font-bold mb-2" data-id="element-15873">
                        {bundle.amount} 💎
                      </div>
                      <div className="text-sm font-medium" data-id="element-15874">{bundle.price}</div>
                      <div className="text-xs text-pink-500 mt-1" data-id="element-15875">
                        {bundle.discount}
                      </div>
                    </div>
                  </div>)}
              </div>
              <button className="w-full py-2.5 bg-gray-100 dark:bg-gray-800 rounded-lg text-gray-600 dark:text-gray-400 text-sm font-medium" onClick={() => setShowGemPurchase(false)} data-id="element-15876">
                Cancel
              </button>
            </div>
          </div>
        </div>}
      {/* Success Toast */}
      {showSuccessToast && <div className="fixed bottom-4 left-1/2 transform -translate-x-1/2 z-50 bg-white dark:bg-gray-900 rounded-lg shadow-lg border border-gray-200 dark:border-gray-800 p-4 flex items-center gap-3 animate-in slide-in-from-bottom duration-300" data-id="element-15877">
          <div className="w-8 h-8 bg-green-100 dark:bg-green-900/30 rounded-full flex items-center justify-center" data-id="element-15878">
            <CheckCircle size={18} className="text-green-600 dark:text-green-400" data-id="element-15879" />
          </div>
          <div data-id="element-15880">
            <p className="font-medium" data-id="element-15881">Premium Purchase Complete!</p>
            <p className="text-sm text-gray-600 dark:text-gray-400" data-id="element-15882">
              You're one step closer to today's rewards.
            </p>
          </div>
        </div>}
      <style jsx data-id="element-15883">{`
        .scrollbar-hide::-webkit-scrollbar {
          display: none;
        }
        .scrollbar-hide {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
        .line-clamp-1 {
          display: -webkit-box;
          -webkit-line-clamp: 1;
          -webkit-box-orient: vertical;
          overflow: hidden;
        }
      `}</style>
    </div>;
};